import * as React from 'react';
import * as Redux from 'react-redux';
import XLSX from 'xlsx-js-style';
import { diasDeSemanaUtil, formatHoraHorarioHelper } from '../../../../helpers';
import BotonComponent from '../../../dashboard/components/BotonNuevo';

const ExportExcelHorarios = () => {
  const loginStore = Redux.useSelector((state) => state.login);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const horariosStore = Redux.useSelector((state) => state.horarios);
  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );

  const diasSemanas = [];
  diasDeSemanaUtil.forEach((el) => {
    const dias = loginStore.isAdminTeacher
      ? docentesStore.activo.diasClases.dias
      : entHorariosClasesStore.activo.dias;
    dias.forEach((item) => {
      if (el.id === item.num || el.dia === item) {
        diasSemanas.push(el);
      }
    });
  });

  const exportToExcel = () => {
    const wb = XLSX.utils.book_new();

    const borderAll = {
      border: {
        left: { style: 'thin', color: { rgb: '000000' } },
        top: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
      },
    };

    const stTitleHeader = {
      fill: { fgColor: { rgb: 'c3c3c3' } },
      font: { bold: true, sz: 14 },
      alignment: { vertical: 'center', horizontal: 'center' },
      ...borderAll,
    };

    const stAlingCell = {
      alignment: { wrapText: true, vertical: 'center', horizontal: 'center' },
      ...borderAll,
    };
    const stCell = { t: 's', s: { ...stAlingCell, font: { bold: true } } };
    const stFill = {
      t: 's',
      s: {
        ...stAlingCell,
        font: { bold: true },
        fill: { fgColor: { rgb: 'c3c3c3' } },
      },
    };

    function inforData(h) {
      // const hora = `${formatHoraHorarioHelper(h.horaInicio)}-${formatHoraHorarioHelper(h.horaFinal)}`

      let string = h
        ? `${h.seccion.nivelAcademico.nivelAcademico.abrev} ${h.seccion.nombre}\n${h.materia.nombre}\n${h.docente.usuario.perfil.pnombre} ${h.docente.usuario.perfil.papellido}`
        : null;

      if (horariosStore.params.idSeccion) {
        string = `${h.materia.nombre}\n${h.docente.usuario.perfil.pnombre} ${h.docente.usuario.perfil.papellido}`;
      }

      if (horariosStore.params.idDocente) {
        string = `${h.seccion.nivelAcademico.nivelAcademico.abrev} ${h.seccion.nombre}\n${h.materia.nombre}`;
      }

      return string;
    }

    const colHeader = [{ v: 'Horas', t: 's', s: stTitleHeader }];

    const dias = loginStore.isAdminTeacher
      ? docentesStore.activo.diasClases.dias
      : entHorariosClasesStore.activo.dias;
    dias.forEach((dia) => {
      colHeader.push({ v: dia.dia, t: 's', s: stTitleHeader });
    });

    let bloquesHoras = [];

    entHorariosClasesStore.activo.bloques.forEach((bloque) => {
      if (bloque.break) {
        bloquesHoras.push([
          {
            v: `${formatHoraHorarioHelper(
              bloque.start,
            )}-${formatHoraHorarioHelper(bloque.end)}`,
            ...stFill,
          },
          { v: 'Libre', ...stFill },
          { v: 'Libre', ...stFill },
          { v: 'Libre', ...stFill },
          { v: 'Libre', ...stFill },
          { v: 'Libre', ...stFill },
        ]);
      } else {
        const rowCol = [
          {
            v: `${formatHoraHorarioHelper(
              bloque.start,
            )}-${formatHoraHorarioHelper(bloque.end)}`,
            ...stCell,
          },
        ];
        entHorariosClasesStore.activo.dias.forEach((dia) => {
          const diaRS = diasSemanas.find((reso) => reso.resourceId === dia.num);

          const horario = horariosStore.all.find(
            (h) =>
              bloque.start === h.horaInicio && h.dia === diaRS.resourceTitle,
          );

          if (horario) {
            rowCol.push({ v: inforData(horario), ...stCell });
          } else {
            rowCol.push({ v: '', ...stCell });
          }
        });

        bloquesHoras.push(rowCol);
      }
    });

    let horarios = [colHeader, ...bloquesHoras];

    const ws = XLSX.utils.aoa_to_sheet(horarios);
    // ws['!merges'] = [
    //     {
    //         s: { r: 2, c: 1 }, // celda inicio del rango combinado
    //         e: { r: 3, c: 1 } // celda fin del rango combinado
    //     }
    // ]

    const colWp = [{ wch: 15 }];
    for (let index = 1; index < 6; index++) {
      colWp.push({ wch: 25 });
    }
    ws['!cols'] = colWp;

    // ws["B3"] = { v: 'HOLALALAL', t: "s" }

    const rowHp = [{ hpt: 17 }];
    for (let index = 0; index < 2; index++) {
      rowHp.push({ hpt: 30 });
    }

    rowHp.push({ hpt: 17 });
    for (let index = 0; index < 6; index++) {
      rowHp.push({ hpt: 30 });
    }

    rowHp.push({ hpt: 17 });
    for (let index = 0; index < 6; index++) {
      rowHp.push({ hpt: 30 });
    }

    ws['!rows'] = rowHp;

    XLSX.utils.book_append_sheet(wb, ws, 'Data');

    const nameSeccion = `horario-nivel-${horariosStore.all[0].seccion.nivelAcademico.nivelAcademico.abrev}-seccion-${horariosStore.all[0].seccion.nombre}`;
    const nameDocente = `horario-docente-${horariosStore.all[0].docente.usuario.perfil.pnombre}-${horariosStore.all[0].docente.usuario.perfil.papellido}`;

    // Generar archivo
    XLSX.writeFile(
      wb,
      `${
        horariosStore.params.idSeccion
          ? nameSeccion
          : horariosStore.params.idDocente
          ? nameDocente
          : 'horario-formato'
      }.xlsx`,
    );
  };

  return (
    <BotonComponent
      click={exportToExcel}
      white
      mr={2}
      saveIcon
      text="Exportar a Excel"
    />
  );
};

export default ExportExcelHorarios;
